<div class="site-search-no-result flex-column gap-10">
  <!-- par nom et adresse du site-->
  <!-- Message pas de résultat-->
  @if (!byLocation) {
    <div>
      {{ "WELCOME.SEARCH.TEXT_NO_RESULT" | transloco }}
    </div>
  }
  <!-- Les possibilités-->
  @if (!byLocation) {
    <div
      class="site-search-no-result-assist flex-column justify-start align-center"
      >
      <div>
        {{ "WELCOME.SEARCH.TEXT_TRY_BY" | transloco }}
        <a mat-button color="primary" (click)="onRetryClick(true)"
          >{{ "WELCOME.SEARCH.CURRENT_LOCATION" | transloco }}</a
          >
        </div>
      </div>
    }

    <!-- par position actuelle -->
    <!-- Message pas de résultat-->
    @if (byLocation) {
      <div>
        {{ "WELCOME.SEARCH.LOCATION_NO_RESULT" | transloco }}
      </div>
    }
    <!-- Les possibilités-->
    @if (byLocation) {
      <div
        class="site-search-no-result-assist flex-column justify-start align-center"
        >
        <a mat-button color="primary" (click)="onRetryClick(true)"
          ><mat-icon>refresh</mat-icon>{{ "WELCOME.SEARCH.RETRY" | transloco }}</a
          >
          <div>
            {{ "WELCOME.SEARCH.SEARCH_BY" | transloco }}
            <a mat-button color="primary" (click)="onRetryClick(false)"
              >{{ "WELCOME.SEARCH.SEARCH_BY_TEXT" | transloco }}</a
              >
            </div>
          </div>
        }
      </div>
